import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'fsGetUrlPartByIdx'
})
export class FsGetUrlPartByIdxPipe implements PipeTransform {

  transform(urlArray: Array<any>, idx: number): string {
    let ret = '';
    for (let i = 0; i <= idx; i++) {
      ret += window.escape(urlArray[i].path) + '/';
    }
    return ret;
  }

}
